import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Event } from '@angular/router';
import { AnimeListService } from 'app/core/services/anime-list.service';
import { Video } from 'app/core/models/core.model';
import { MatSliderChange } from '@angular/material';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})
export class PlayerComponent implements OnInit {
  episode: Video;
  video: HTMLVideoElement;
  isPlaying = true;
  duration = 0;
  currentTime = 0;
  minutes: number;
  seconds: string;
  isVolumeShown: boolean;
  volume: number;
  anime: string;

  constructor(private route: ActivatedRoute, private aniService: AnimeListService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.anime = params['anime'];
      this.aniService.getEpisode(params['anime'], params['episode']).subscribe(res => {
        this.episode = res;
        if (this.video) {
          this.hide(this.getEl('next'));
          this.video.src = this.episode.SourceUri;
        }
      });
    });
  }

  ngAfterViewInit(): void {
    this.video = <HTMLVideoElement>document.getElementById('video' + this.episode.Ep);
    this.video.autoplay = this.isPlaying;
    this.video.onloadedmetadata = () => {
      this.video.volume = 0.5;
      this.volume = Math.floor(this.video.volume * 100);
      setInterval(() => {
        this.duration = this.video.duration;
        if (this.isPlaying) {
          this.currentTime = this.video.currentTime;
          this.minutes = Math.floor((this.duration - this.currentTime) / 60);
          this.seconds = parseFloat(`${(this.duration - this.currentTime) - this.minutes * 60}`).toFixed(0);
          if (this.video.currentTime > this.episode.SkipTimeStart && this.video.currentTime < this.episode.SkipTimeEnd) {
            this.show(this.getEl('skip'));
          } else {
            this.hide(this.getEl('skip'));
          }

          if (this.video.currentTime > this.episode.NextEpTime) {
            this.show(this.getEl('next'));
          }

        }
      }, 1000);
    }
  }

  getEl(clas: string): HTMLElement {
    return <HTMLElement>document.querySelector(`.${clas}`);
  }
  skipOppening() {
    this.video.currentTime = this.episode.SkipTimeEnd;
    if (!this.isPlaying) {
      this.play();
    }
  }
  hide(el:HTMLElement) {
    el.style.opacity = '0';
    el.style.zIndex = '999999';
  }
  show(el) {
    el.style.opacity = '1';
    el.style.zIndex = '9999999'
  }

  play() {
    if (this.isPlaying) {
      this.video.pause();
    } else {
      this.video.play();
    }
    this.isPlaying = !this.isPlaying;
  }

  setTime(event: MatSliderChange) {
    this.video.currentTime = event.value;
  }

  fullscreen() {
    this.video.webkitEnterFullScreen();
  }

  showVolume(event) {
    const el = <HTMLElement>document.querySelector('.sound');
    if (this.isVolumeShown) {
      el.style.display = 'none';
    } else {
      el.style.display = 'block';
    }
    this.isVolumeShown = !this.isVolumeShown;
  }

  setVolume(event: MatSliderChange) {
    const vid = <any>this.video;
    vid.volume = parseFloat(`${event.value / 100}`).toFixed(1);
  }

}
